import { withRouter } from "react-router-dom";

import { darken } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";

import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import PortalNavDrawer from "../ui/portalNavDrawer";
import BotpressMemberVerifiedAnswers from "../widgets/botpressMemberVerifiedAnswers";
import BotpressMembers from "../widgets/botpressMembers";
import BotpressSiteMap from "../widgets/botpressSiteMap";

const BotpressAdminPortal = props => {
  const theme = useTheme();

  return (
    <Portal
      displayHeader={false}
      sx={{
        backgroundSize: "cover",
        backgroundColor: darken(theme.palette.commonground.main, 0.4),
      }}
    >
      <PortalAppBar title="Botpress Admin Portal" botpressStyle={true} />
      <PortalNavDrawer />
      <PortalGridContent hasNavDrawer>
        <Grid size={{ xs: 12 }}>
          <BotpressMembers minHeight={"0px"} />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <BotpressSiteMap minHeight={"0px"} />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <BotpressMemberVerifiedAnswers variant="admin" readOnly minHeight={"0px"} />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: 4 }} />
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(BotpressAdminPortal);
